import React, {useCallback, useMemo} from "react";
import {Controller, UseFormReturn} from "react-hook-form";
import {validateRule} from "./heplers";

interface FormControllerProps<T> {
  onUpdate?: any
  control: UseFormReturn<any>['control']
  rules?: any
  errors?: any
  name: keyof T,
  [x: string]: any
}

function FormControllerComponent<FormModel, AsProps = {}>({ onUpdate, rules, errors, ...rest}: FormControllerProps<FormModel> & AsProps ) {
  const rules_ = useMemo(() => rules ? validateRule(rules) || rules : undefined, [rules]);
  const onChange_ = useCallback(([e, value]: any) => {
    let value_ = '';
    if (
      e.target &&
      e.target.value !== undefined &&
      e.target.value !== null &&
      e.target.type !== 'checkbox'
    ) {
      value_ = e.target.value;
    } else if (
      value !== undefined
      && value !== null
    ) {
      value_ = value;
    }
    // if (onUpdate) onUpdate(rest.name, e.target.value, value);
    return value_;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onUpdate]);

  const _name = String(rest.name)
  // v6 `as` + `onChange` transform -> v7 `render` (RHF phase). The element still
  // receives the extra props, `error`, `_name` and the field bindings, as v6 cloned them.
  const {as: Element, control, name: _name_, ...elementProps} = rest as any;

  return <Controller
    control={control}
    rules={rules_}
    name={_name}
    render={({field}) =>
      <Element
        {...elementProps}
        {...field}
        error={errors ? errors[_name] : undefined}
        _name={_name}
        onChange={(...args: any[]) => field.onChange(onChange_(args))}
      />
    }
  />
}
export const FormController = React.memo(FormControllerComponent) as typeof FormControllerComponent
export default FormController;
